import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row,Typography } from "antd";
import { AdminLogHistoryParams } from "api";
import dayjs from "dayjs";
import { ActivityLogView } from "features/log/components/activity-log/activity-logView";
import { EditLogModalView } from "features/log/components/modal/editModalLog";
import { AddEntryAccpetRejectModal } from "features/log/components/modal/EntryLogAccpetReject-modal";
import { AddExitAccpetRejectModal } from "features/log/components/modal/ExitLogAccpetReject-modal";
import { useGetLogActivityList } from "features/log/use-cases/get-ActivityLogHistory";
import { useGetAdminVehicleLogList } from "features/log/use-cases/get-log-history";
import { ArrowLeft } from "lucide-react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// ../components/modal/editModalLog



const { Title, Text } = Typography;

export const LogDetails = () => {
  const { id } = useParams();
  const payload: AdminLogHistoryParams = { EntryId: id };
  const { data } = useGetAdminVehicleLogList(payload);
  const Qrcode = data?.res?.qrCode;
  const navigate = useNavigate()
  const parmas: any = {
    QrCode: Qrcode
  }


  const { data: ActivityLog, isFetching: isLoading } =
    useGetLogActivityList(parmas, {
      enabled: !!Qrcode, // ✅ will only run if Qrcode is truthy
    }); // ✅ won't fire until Qrcode is truthy)
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false)
  const [showModalExit, setShowModalExit] = useState(false);
  const [selectLogId, setSelectedId] = useState("");
  const [approveReject, setApproveReject] = useState<"Approve" | "Reject">(
    "Approve"
  );
  const apiData = data?.res;
  const activitylogdata = ActivityLog?.rc
  const onhandleEditModel = () => {
    setShowEditModal(true)
  }

  return (
    <div style={{ padding: 20, background: "#f5f7fa", minHeight: "100vh" }}>
      <Row gutter={20}>
        {/* Left Side - Entry Logs Details */}
        <Col xs={24} md={14}>
          <Card
            title={
              <div className="flex items-center gap-2 w-full">
                <ArrowLeft
                  className="cursor-pointer"
                  onClick={() => navigate(-1)}
                  size={18}
                />

                <span>Entry/Exit Logs Details</span>
             
              </div>
            }
            extra={
              <div className="hed_btn">
                   <Button type="primary"     onClick={onhandleEditModel}>
                  Edit
                </Button>
                {apiData?.isApprovedForExit == 2 && apiData?.isExit == false ? (
                  <>
                    <Button
                      type="primary"
                      onClick={() => {
                        setShowModal(true);
                        setApproveReject("Approve");
                      }}
                    >
                      Accept
                    </Button>
                    <Button
                      type="default"
                     
                      onClick={() => {
                        setShowModal(true);
                        setApproveReject("Reject");
                      }}
                    >
                      Reject
                    </Button>
                  </>
                ) : 
                apiData?.isApprovedForExit == 1 &&
                  apiData?.isExit == false ? (
                  <Button
                    type="default"
                   
                    onClick={() => {
                      setShowModal(true);
                      setApproveReject("Reject");
                    }}
                  >
                    Reject
                  </Button>
                ) : apiData?.isApprovedForExit == 3 &&
                  apiData?.isExit == false ? (
                    <Button
                    type="primary"
                    onClick={() => {
                      setShowModal(true);
                      setApproveReject("Approve");
                    }}
                  >
                    Accept
                  </Button>
                ) : null}

                {apiData?.isExit ? (
                  apiData?.isApprovedForExit === 1 ? (
                    <span className="text-green-600 font-semibold">Approved</span>
                  ) : apiData?.isApprovedForExit === 3 ? (
                    <span className="text-red-600 font-semibold">Rejected</span>
                  ) : (
                    <span className="text-yellow-600 font-semibold">Pending</span>
                  )
                ) : null}

              </div>
            }
            style={{ borderRadius: 12 }}
          >
            <div className="mb-5 flex flex-col gap-1">
              <Title level={5}>{apiData?.vehicleNumber || ""}</Title>

              {/* Entry Type Row */}
              <div className="flex items-center gap-2">
                <label className="font-bold text-gray-800 text-sm">Entry Type:</label>
                <span>
                  {apiData?.entryType === 1
                    ? "Sale"
                    : apiData?.entryType === 2
                      ? "Store"
                      : apiData?.entryType === 3
                        ? "Purchase"
                        : ""}
                </span>
              </div>
              {/* Entry Time Row */}
              <div className="flex items-center gap-2">
                <span className="font-bold text-gray-800 text-sm">Entry Time:</span>
                <span>
                  {apiData?.inTime
                    ? dayjs(apiData.inTime).format("MMMM Do YYYY h:mm a")
                    : "-"}
                </span>
              </div>
              {/* Driver Info Row */}
              <div className="flex items-center gap-2">
                <span className="font-bold text-gray-800 text-sm">Driver:</span>
                <span>
                  {apiData?.driverName} | {apiData?.driverId}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="font-bold text-gray-800 text-sm">

                  {apiData?.entryType === 1
                    ? "Customer"
                    : "Supplier"}
                  :</span>
                <span>
                  {apiData?.supplierName}
                </span>
              </div>
              {apiData?.entryType === 2 ? (
                <>
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-gray-800 text-sm">

                      Entry Weight
                      :</span>
                    <span>
                      {apiData?.entryWeight}
                    </span>

                  </div>
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-gray-800 text-sm">

                      Exit Weight
                      :</span>
                    <span>
                      {apiData?.exitWeight}
                    </span>

                  </div>
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-gray-800 text-sm">

                      Net Weight
                      :</span>
                    <span>
                      {apiData?.netWeight}
                    </span>

                  </div>

                </>

              ) : null}

            </div>
            {apiData?.logsList && apiData.logsList.length > 0 ? (
              apiData.logsList.map((log: any, index: number) => (
                <Card
                  key={index}
                  style={{ marginBottom: 15, borderRadius: 10 }}
                  bodyStyle={{ padding: 16 }}
                >
                  <Row gutter={24} align="middle">
                    <Col span={24}>
                      <Text strong className="text-lg mb-2 block">{log.materialName} </Text>
                      <div className="materialInfo">
                        <div className="">
                          <label className="text-gray-900 font-medium">In Time:</label> {" "}
                          {log?.inTime
                            ? dayjs(log.inTime).format("MMMM Do YYYY h:mm a")
                            : "-"}
                        </div>
                        {log?.entryType == 2 ? (
                          <>
                            <div>
                              <label className="text-black">Material Name : </label>{log?.materialName || ""}
                            </div>
                            <div> <label className="text-black">Remark: </label>{log?.remark || "--"}</div>
                          </>
                        ) : (
                          <>
                            <div>
                              <span className="text-gray-900 font-medium">Material Name: </span> {log?.materialName || ""}
                            </div>
                            {apiData?.entryType == 1 &&
                              <div>
                                <span className="text-gray-900 font-medium"> Expected Weight: </span>
                                {/* {log?.expectedWeight || ""} */}
                                {log?.expectedWeight != null
                                  ? `${Number(log.expectedWeight) % 1 === 0
                                    ? Number(log.expectedWeight).toFixed(0)
                                    : Number(log.expectedWeight).toFixed(2)
                                  } kg`
                                  : "--"}

                              </div>
                            }

                            <div><label className=" text-gray-900 font-medium">Net Weight:</label>
                              {/* {log?.netWeight || "--"} */}
                              {log?.netWeight != null
                                ? `${Number(log.netWeight) % 1 === 0
                                  ? Number(log.netWeight).toFixed(0)
                                  : Number(log.netWeight).toFixed(2)
                                } kg`
                                : "--"}
                            </div>
                            <div>
                              <span className="text-gray-900 font-medium"> Entry Weight: </span>
                              {log?.entryWeight != null
                                ? `${Number(log.entryWeight) % 1 === 0
                                  ? Number(log.entryWeight).toFixed(0)
                                  : Number(log.entryWeight).toFixed(2)
                                } kg`
                                : "--"}
                              {/* {log?.entryWeight || "--"} */}
                            </div>
                            <div>
                              <span className="text-gray-900 font-medium">Exit Weight:</span>
                              {log?.exitWeight != null
                                ? `${Number(log.exitWeight) % 1 === 0
                                  ? Number(log.exitWeight).toFixed(0)
                                  : Number(log.exitWeight).toFixed(2)
                                } kg`
                                : "--"}
                              {/* {log?.exitWeight || "--"} */}
                            </div>
                            {apiData?.entryType == 1 &&
                              <>
                                <div>
                                  <label className="text-gray-900 font-medium">Total Bundle: </label>

                                  {log?.totalBundle || "--"}
                                </div>
                                <div>
                                  <label className="text-gray-900 font-medium">Total Loose Pcs:</label> {log?.totalLoosePcs || "--"}
                                </div>

                              </>}
                            {apiData?.entryType == 3 && (
                              <>
                                <div>
                                  <span className=" text-gray-900 font-medium">Dust In Kg:</span>
                                  {/* {log?.dustInKg || "--"} */}

                                  {log?.dustInKg != null
                                    ? `${Number(log.dustInKg) % 1 === 0
                                      ? Number(log.dustInKg).toFixed(0)
                                      : Number(log.dustInKg).toFixed(2)
                                    } kg`
                                    : "--"}

                                </div>
                                <div>
                                  <span className=" text-gray-900 font-medium">Dust In Percentage:</span>
                                  {/* {log?.dustInPercentage || "--"} */}
                                  {log?.dustInPercentage != null
                                    ? `${Number(log.dustInPercentage) % 1 === 0
                                      ? Number(log.dustInPercentage).toFixed(0)
                                      : Number(log.dustInPercentage).toFixed(2)
                                    } %`
                                    : "--"}

                                </div>
                                <div>
                                  <span className=" text-gray-900 font-medium">Total Dust Weight:</span>
                                  {/* {log?.totalDustWeight || "--"} */}
                                  {log?.totalDustWeight != null
                                    ? `${Number(log.totalDustWeight) % 1 === 0
                                      ? Number(log.totalDustWeight).toFixed(0)
                                      : Number(log.totalDustWeight).toFixed(2)
                                    } kg`
                                    : "--"}
                                </div>
                                <div>
                                  <span className=" text-gray-900 font-medium">Final Net Weight:</span>
                                  {/* {log?.finalNetWeight || "--"} */}
                                  {log?.finalNetWeight != null
                                    ? `${Number(log.finalNetWeight) % 1 === 0
                                      ? Number(log.finalNetWeight).toFixed(0)
                                      : Number(log.finalNetWeight).toFixed(2)
                                    } kg`
                                    : "--"}
                                </div>
                              </>
                            )}

                            <div>
                              <span className="text-gray-900 font-medium">Remark:</span> {log?.remark || "--"}
                            </div>
                            {log?.totalLoosePcs &&
                              <div>
                                <label className="text-gray-900 font-medium">Total Pcs:</label> {log?.totalPieces || "--"}
                              </div>}
                            {log?.weightType && (
                              <div>
                                <label className="text-gray-900 font-medium">Weight Type:</label>{" "}
                                <span
                                  className={
                                    log.weightType === "OverWeight"
                                      ? "text-red-600 font-semibold"
                                      : log.weightType === "UnderWeight"
                                        ? "text-green-600 font-semibold"
                                        : "text-gray-500"
                                  }
                                >
                                  {log.weightType}
                                </span>
                              </div>
                            )}
                            {log?.status && (
                              <div
                                className={`font-semibold ${log.status.toLowerCase() === "approved"
                                  ? "text-green-600"
                                  : log.status.toLowerCase() === "rejected"
                                    ? "text-red-600"
                                    : "text-gray-800"
                                  }`}
                              >
                                <label className="text-black">Status: </label>{log.status}
                              </div>

                            )}

                          </>
                        )}
                        {log?.entryType == 3 &&
                          (log?.isApproved == 2 || log?.isApproved == 0) ? (
                          <div style={{ marginTop: 10 }}>
                            <Button
                              type="primary"
                              icon={<CheckCircleOutlined />}
                              style={{ marginRight: 8 }}
                              onClick={() => {
                                setShowModalExit(true);
                                setApproveReject("Approve");
                                setSelectedId(log?.logId);
                              }}
                            >
                              Approve
                            </Button>
                            <Button
                              danger
                              icon={<CloseCircleOutlined />}
                              onClick={() => {
                                setShowModalExit(true);
                                setApproveReject("Reject");
                                setSelectedId(log?.logId);
                              }}
                            >
                              Reject
                            </Button>
                          </div>
                        ) : log?.entryType == 3 && log?.isApproved == 1 ? (
                          <div style={{ marginTop: 10 }}>
                            <Button
                              danger
                              icon={<CloseCircleOutlined />}
                              onClick={() => {
                                setShowModalExit(true);
                                setApproveReject("Reject");
                                setSelectedId(log?.logId);
                              }}
                            >
                              Reject
                            </Button>
                          </div>
                        ) : log?.entryType == 3 && log?.isApproved == 3 ? (
                          <div style={{ marginTop: 10 }}>
                            <Button
                              type="primary"
                              icon={<CheckCircleOutlined />}
                              style={{ marginRight: 8 }}
                              onClick={() => {
                                setShowModalExit(true);
                                setApproveReject("Approve");
                                setSelectedId(log?.logId);
                              }}
                            >
                              Approve
                            </Button>
                          </div>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            ) : (
              <Text type="secondary">No logs available</Text>
            )}
          </Card>
        </Col>
        {/* Right Side - Activity Timeline */}
        <Col xs={24} md={10}>
          <ActivityLogView activitylogdata={activitylogdata} isLoading={isLoading} />
        </Col>

      </Row>
      {/* Modals */}
      {showModal && (
        <AddEntryAccpetRejectModal
          onClose={() => setShowModal(false)}
          isModalOpen={showModal}
          approveReject={approveReject}
          log={apiData}
        />
      )}
      {showModalExit && (
        <AddExitAccpetRejectModal
          onClose={() => setShowModalExit(false)}
          isModalOpen={showModalExit}
          approveReject={approveReject}
          log={apiData}
          selectLogId={selectLogId}
        />
      )}
      {showEditModal && (
        <EditLogModalView
          setShowEditModal={setShowEditModal}
          showEditModal={showEditModal}
          apiData={apiData}
        />
      )

      }
    </div>
  );
};
